import React from "react";
import {
  ActivityItemProps,
  CommentSummaryProps,
} from "./types/workOrderActivityTypes";
import { WorkOrderHistory } from "components/QueueBoard/models/workOrderTypes";
import { WorkOrderAttachmentActivityProps } from "./records/activityPropsRecordsUtility";
import {
  Typography,
  Box,
  Button,
  Stack,
  CardContent,
  useTheme,
} from "@mui/material";
import { EntityTypeEnum } from "./enums/workOrderActivity.enums";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const AttachmentActivityView = ({
  color,
  user,
  action,
  target,
  entity,
  setCurrentTabIndex,
}: ActivityItemProps) => {
  const theme = useTheme();
  const handleViewDetail = () => {
    setCurrentTabIndex(1); // or whatever tab index you want to switch to
  };

  const renderEntityContent = () => {
    switch (entity.relatedEntity) {
      case EntityTypeEnum.SegAttachment:
        return (
          <Stack spacing={1} direction="column">
            <Typography variant="body2">
              <strong>{user}</strong>{" "}
              {action === "created"
                ? "uploaded"
                : action === "updated"
                ? "updated"
                : "removed"}{" "}
              <strong>
                {entity.relatedEntity === EntityTypeEnum.SegAttachment
                  ? "an Attachment"
                  : "an Image"}
              </strong>{" "}
              {action === "removed" ? "from" : "to"}{" "}
              <strong>{entity.segmentName}</strong>
            </Typography>
            <Button
              variant="outlined"
              size="small"
              sx={{
                alignSelf: "start",
                textTransform: "none",
                borderRadius: 2,
                fontWeight: 500,
              }}
              onClick={handleViewDetail}
            >
              View Attachment
            </Button>
          </Stack>
        );

      //case EntityTypeEnum.SegAttachmentImage:

      default:
        return (
          <Stack spacing={1} direction="column">
            <Typography variant="body2">
              <strong>{user}</strong>{" "}
              {action === "created"
                ? "uploaded"
                : action === "updated"
                ? "updated"
                : "removed"}{" "}
              <strong>
                {entity.relatedEntity === EntityTypeEnum.SegAttachment
                  ? "an Attachment"
                  : "an Image"}
              </strong>{" "}
              {action === "removed" ? "from" : "to"}{" "}
              <strong>{entity.segmentName}</strong>
            </Typography>
            <Button
              variant="outlined"
              size="small"
              sx={{
                alignSelf: "start",
                textTransform: "none",
                borderRadius: 2,
                fontWeight: 500,
              }}
              onClick={handleViewDetail}
            >
              View Attachment
            </Button>
          </Stack>
        );
    }
  };
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={1}
      mb={1}
      sx={{
        backgroundColor: theme.palette.mode === "light" ? "#fff" : "#181F2A",
        borderRadius: 1,
        p: 1,
      }}
    >
      <FiberManualRecordIcon sx={{ fontSize: 12, color, mt: "4px" }} />
      {renderEntityContent()}
    </Box>
  );
};

export default AttachmentActivityView;
